<div ng-if="editor.isDesigning()" ng-show="isDragged" class="shadow"></div>
<c-form-element-actions ng-if="editor.isDesigning()" editor="editor" element="field"></c-form-element-actions>
<label ng-class="{selectable:editor.isDesigning()}" ng-mousedown="editor.dragBegin(field, $event)" title="{{(editor.isDesigning() ? 'move':'')|translate}}" ng-bind-html="labelText"></label>
<span class="field-description" ng-if="!tool" ng-bind-html="descriptionText"></span>
<div class="select-search-wrapper" ng-if="tool || editable">
    <c-dropdown-table-select items="lookupItems" callback="callback" hide-headers="hideHeaders"></c-dropdown-table-select>
</div>
<c-simple-list configuration="nodeListConfig" items="nodeItems"></c-simple-list>
